import React from "react";
import "./container.css";
function Container() {
  return (
    <div className="row rowbg">
      <div className="col l7 m7 s12 xs12 hello">
        <img className="law2" src="law2.png" alt="" />
      </div>
      <div className="col l5 m5 s12 xs12  contain-right">
        <h1 className="lo">LAWYERS ONLINE</h1>
        <p className="contain-para">
          In technical sense Lawyers Online may be termed as a portal and being
          a law portal, it offers the basic functionalities of a web portal
          which encompass searching of Laws, Case Laws, and notifications as
          well as finding lawyers in Faisalabad.
        </p>
        <a href="aboutus" className="button">
          Read More
        </a>
      </div>
    </div>
  );
}
export default Container;

{
  /* <div className="hero">
      <div className="row">
        <div className="col m8 s12">
          <figure>
            <img className="law2" src="law2.png" alt="" />
          </figure>
        </div>
        <div className="col m4 s12">
          <div className="content">
            <h1>LAWYERS ONLINE</h1>
            <p>
              In technical sense Lawyers Online may be termed as a portal and
              being a law portal, it offers the basic functionalities of a web
              portal which encompass searching of Laws, Case Laws, and
              notifications as well as finding lawyers in Faisalabad.
            </p>
            <a href="aboutus" className="button">
              Read More
            </a>
          </div>
        </div>
      </div>
    </div> */
}
